var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880 1986 c-82 -21 -138 -48 -205 -99 -256 -194 -280 -572 -50 -802 67 -67 174 -126 263 -144 335 -69 644 183 644 524 0 290 -221 519 -512 531 -52 2 -107 -2 -140 -10z m266 -157 c77 -29 165 -113 206 -197 31 -62 33 -74 33 -167 0 -91 -3 -106 -31 -165 -56 -118 -160 -197 -292 -222 -165 -31 -341 63 -416 222 -28 59 -31 74 -31 165 0 88 3 107 27 158 52 111 165 203 278 227 62 12 160 3 226 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 779 c-350 -45 -644 -259 -790 -577 -46 -99 -53 -152 -24 -181 l21 -21 910 0 c897 0 910 0 930 20 28 28 25 69 -12 158 -67 161 -205 329 -354 432 -200 138 -448 200 -681 169z m377 -177 c212 -70 404 -231 499 -419 l21 -43 -780 0 -780 0 21 42 c89 177 285 348 469 410 122 41 169 47 315 44 125 -3 150 -7 235 -34z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.58438da5bc3f4b571c6f6ef65588b3ff.svg";
export { ForwardRef as ReactComponent };